import { render } from "./Sch.vue?vue&type=template&id=03d78b75&scoped=true"
import script from "./Sch.vue?vue&type=script&lang=js"
export * from "./Sch.vue?vue&type=script&lang=js"

import "./Sch.vue?vue&type=style&index=0&id=03d78b75&scoped=scoped&lang=scss"

import exportComponent from "D:\\work\\粤智康医药网\\guanwang\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03d78b75"]])

export default __exports__